import axios from 'axios';
import { CHAT_DOMAIN } from '../constants';
import { generateUUID } from '../utils/utils';

// eslint-disable-next-line no-restricted-globals
const baseURL = location.hostname === 'localhost' ? '/api/v4' : CHAT_DOMAIN;

export const getMyAuthToken = () => {
  return axios.get('/api/mattermost/user_token');
};

export const getChats = (page: number, per_page: number, archived?: boolean) => {
  return axios.get(`/api/mattermost/user_channels`, {
    params: {
      archived: archived || undefined,
      page,
      per_page,
    },
  });
};

export const getChat = (company_id?: string | number, user_id?: string | number) => {
  return axios.post(
    `/api/mattermost/group_channel`,
    {},
    {
      params: {
        company_id,
        user_id,
      },
    }
  );
};

export const getPostsForChannel = (channelId: string, page: number, before?: string) => {
  let url = `/channels/${channelId}/posts?page=${page}&per_page=1000`;
  if (before) {
    url += `&before=${before}`;
  }
  return axios.get(url, { baseURL });
};

export const createPost = (
  channelId: string,
  message: string,
  props?: {},
  fileIds?: string[]
) => {
  const data = {
    channel_id: channelId,
    message,
    props: props || {},
    file_ids: fileIds,
  };
  return axios.post('/posts', data, { baseURL });
};

export const getMe = () => {
  return axios.get('/users/me', { baseURL });
};

export const uploadFile = (channelId: string, file: File, name: string) => {
  const formData = new FormData();
  formData.append('channel_id', channelId);
  formData.append('client_ids', generateUUID());
  formData.append('files', file);
  const url = `/files?channel_id=${channelId}&fileName=${name}`;
  const options = {
    headers: { 'Content-Type': 'multipart/form-data' },
    baseURL,
  };
  return axios.post(url, formData, options);
};

export const getUploadedFile = (id: string, isPreview?: boolean) => {
  return axios.get(`/files/${id}${isPreview ? '/preview' : ''}`, {
    baseURL,
    responseType: 'blob',
  });
};
